/**
 * @class
 */
class StringExtender {
  constructor() {
    String.prototype.toCapitalLetters = this.toCapitalLetters;
    String.prototype.toSnakeCase      = this.toSnakeCase;
    String.prototype.toPascalCase     = this.toPascalCase;
  }

  /**
   *
   * @param {string} string
   * @return {string}
   */
  static toCapitalLetters(string) {
    if (!string || typeof string !== 'string') {
      return '';
    }
  
    return string.toCapitalLetters();
  }

  /**
   * @param {string} string
   * @return {string}
   */
  static toSnakeCase(string) {
    if (!string || typeof string !== 'string') {
      return '';
    }
  
    return string.toSnakeCase();
  }

  toPascalCase() {
    const blocks      = this.trim().split(/[\s\-_+]/);
    const finalResult = [];

    blocks.forEach(block => {
      const capitalized = block.substr(0, 1).toUpperCase() + block.substr(1);

      if (!block.trim()) {
        return;
      }

      finalResult.push(capitalized);
    });

    return finalResult.join('');
  }

  /**
   * @param {string} string
   * @return {string}
   */
  static toPascalCase(string) {
    if (!string || typeof string !== 'string') {
      return '';
    }
  
    return string.toPascalCase();
  }

  /**
   * Metodo che formatta il testo passato mettendo la prima lettera di ogni parola in Masiuscolo,
   * mentre le altre in minuscolo.
   *
   * Il metodo tiene conto delle preposizioni che ci possono essere nella stringa e di conseguenza
   * evita di impostarle con la lettera maiuscola.
   *
   * @example
   * var text = "testo Con LetTere non corrette";
   * text.toCapitalLetters()  -> "Testo con Lettere Non Corrette"
   *
   * @example
   * var text = "il testo dell'anno con preposizioni.";
   * text.toCapitalLetters() -> "Il Testo dell'Anno con Preposizioni."
   *
   * @return {String}
   */
  toCapitalLetters() {
    var to_return                 = [];
    var blocks                    = this.split(' ');
    var preposizioni              = ['di', 'a', 'da', 'in', 'con', 'su', 'per', 'tra', 'fra'];
    var preposizioni_articolate   = ['del', 'al', 'dal', 'nel', 'sul', 'dello', 'allo',
      'dallo', 'nello', 'sullo', 'della', 'alla', 'dalla', 'nella', 'sulla', 'dei', 'ai',
      'dai', 'dei', 'sui', 'degli', 'agli', 'dagli', 'negli', 'sugli', 'delle', 'alle', 'dalle', 'nelle', 'sulle'
    ];
    var preposizione_con_articolo = ['dell', 'all', 'dall', 'nell', 'sull', 'd'];
  
    blocks.map(function (stringa) {
      var has_preposizione = stringa.toLowerCase().match(/([a-z]\w*)/gi);
    
      if (has_preposizione && preposizioni.concat(preposizioni_articolate).indexOf(has_preposizione[0]) > -1) {
        to_return.push(stringa.toLowerCase());
      
      } else if (stringa.indexOf('\'') > -1 && stringa.indexOf('\'') < stringa.length - 1) {
        var apostrofo_index         = stringa.indexOf('\'');
        var test_prima_di_apostrofo = stringa.substr(0, apostrofo_index).toLowerCase();
      
        if (preposizione_con_articolo.indexOf(test_prima_di_apostrofo) > -1) {
          to_return.push(
            stringa.substr(0, apostrofo_index).toLowerCase() +  // testo prima dell'apostrofo
            '\'' +
            stringa.substr(apostrofo_index + 1, 1).toUpperCase() + // Prima lettera dopo l'apostrofo, convertita in maiuscolo
            stringa.substr(apostrofo_index + 2).toLowerCase() // aggiungiamo il resto del testo in minuscolo
          );
        } else {
          to_return.push(stringa.toLowerCase());
        }

      } else {
        /**
         * Ritorna la posizione del primo carattere testuale valido.
         * Solitamnete la posizione ? 0, ma nel caso in cui ci siano parentesi
         * o caratteri speciali, la posizione cambia.
         *
         * @type {number}
         */
        var first_letter_index = stringa.search(/[a-zàèéìòù]/gi);

        if (first_letter_index === -1) {
          first_letter_index = 0;
        }

        to_return.push(
          stringa.substr(0, first_letter_index) +
          stringa.substr(first_letter_index, 1).toUpperCase() + // Trtasformiamo la prima lettera della stringa in maiuscola
          stringa.substr(first_letter_index + 1).toLowerCase() // aggiungiamo il resto del testo in minuscolo
        );
      }
    });

    return to_return.join(' ');
  }

  toSnakeCase() {
    const splitted = this.split(/(?=[A-Z])|(\s)|(?=-)/);
    const blocks   = [];
  
    splitted.map(function(str, index) {
      if (!str || (str && !(str.trim()))) {
        return;
      }
  
      blocks.push(str.replace('-', '').trim());
    });
  
    return blocks.join('_').toLowerCase();
  }
}

export default new StringExtender();
export { StringExtender };
